import React, { useEffect } from 'react'
import Header from '../components/Header'
import { Footer } from '../containers'
import { AuthButtonWithProvider } from '../components'
import {FaGoogle,FaGithub} from 'react-icons/fa6'
import { toast } from 'react-toastify'
import useUser from '../hooks/useUser'
import { useNavigate } from 'react-router-dom'
import MainSpinner from '../components/MainSpinner'

function Authentication() {
  const {data, isLoading, isError}=useUser()
  const navigate=useNavigate()
  useEffect(()=>{
    if(!isLoading&& data){
      navigate("/",{replace:true})
    }
  },[isLoading,data])
  if(isLoading){
    return <MainSpinner/>
  }
  return (
    <>
    <Header />
    <div className='auth-section'>
        {/* top section*/}
        
      {/*main section*/}
      <div className='w-full flex flex-1 flex-col items-center justify-center gap-6'>
        <h1 className='text-3xl lg:text-4xl text-blue-700'>Welcome to Resume Snap</h1>
        <p className='text-2xl text-gray-600'>express way to create resume</p>
        <h2 className='text-2xl text-gray-600'>Authenticate</h2>
        <div className='w-full lg:w-96 rounded-md  p-2 flex flex-col items-center justify-start gap-6'>
            <AuthButtonWithProvider Icon={FaGoogle} label={"Signin with Google"}
            provider={"GoogleAuthProvider"}/>
  <AuthButtonWithProvider Icon={FaGithub} label={"Signin with GitHub"}
            provider={"GitHubAuthProvider"}/>

          
        </div>
       </div>
      
    </div>
    {/** footer section */}
      <Footer></Footer>
    </>
  )
}

export default Authentication
